export default {
	INIT: 'INIT',

	ENGINE: 'ENGINE',

	REQUEST: 'REQUEST',

	FILTERS: 'FILTERS',
	GEO_DATA: 'GEO_DATA',

	RESULTS_PER_PAGE: 'RESULTS_PER_PAGE',
	SORT: 'SORT',
	PAGE: 'PAGE',
	RESULT_CONTROLS: 'RESULT_CONTROLS',
	
	PRODUCTS: 'PRODUCTS',
	COUNTERS: 'COUNTERS',
	MAP: 'MAP',
	RESULTS: 'RESULTS',

	ALL: 'ALL',
}